<script setup lang="ts">
import { JobForm } from '~/lib/fw';

interface Props {
  pastas: string[];
}

const props = defineProps<Props>();
const emit = defineEmits(['close']);

function irParaSolic() {
  window.location.href = '/solic';
}
</script>

<template>
  <div style="padding-bottom: 24px">
    <DrawerTitle @close="() => emit('close')">
      <template #title>
        <span style="font-size: 16px; font-weight: 500; line-height: 35px">
          ENVIAR EMAILS PARA SOLIC EM LOTE
        </span>
      </template>
    </DrawerTitle>

    <div style="padding: 0 24px">
      <JobForm
        action="solic/enviar-emails-para-solic-em-lote"
        :initial-model="{ pastas: props.pastas }"
        :pre-submit="async (data: any) => ({ continue: true, data: { pastas: data.pastas.value } })"
        :wait-for-result="false"
        submit-button-text="Enviar"
        submit-button-block
        :submit-button-icon-visible="false"
      >
        <template #form>
          <a-alert
            message="Atenção: Você está prestes a enviar e-mails em lote para a Solic."
            type="warning"
            style="margin-bottom: 24px"
            show-icon
          />
        </template>
        <template #submitSuccess>
          <a-result
            status="success"
            title="Os emails estão sendo enviados para a Solic"
            sub-title="Você pode verificar o resultado na página da Solic"
          >
            <template #extra>
              <a-button @click="irParaSolic"> Ir para Solic </a-button>
              <a-button @click="() => emit('close')"> Fechar </a-button>
            </template>
          </a-result>
        </template>
      </JobForm>
    </div>
  </div>
</template>
